import { Layout } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { getRoutes } from '../constants/Routes';
import _ from 'lodash';
import { Navigate, Route, Routes } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import useAuth from '../hooks/useAuth';
import NotFound from '../pages/NotFound';
import { ROLES } from '../constants';
import { getRestaurants } from '../redux/actions/restaurant';

const { Content } = Layout;

const AppLayout = () => {
  const { token, role, user } = useAuth();
  const [dashboardPath, setDashboardPath] = useState('');

  const [publicRoutes, setPublicRoutes] = useState(
    _.filter(Object.values(getRoutes()), (route) => !route?.permission)
  );
  const [privateRoutes, setPrivateRoutes] = useState(
    _.filter(Object.values(getRoutes()), (route) => route?.permission)
  );

  const getStaffRestaurants = useCallback(async () => {
    if (!user?.restaurants?.length) return;
    const res = await getRestaurants();
    if (res.ack) {
      setDashboardPath(getRoutes().restaurant_detail.route(user?.restaurants?.at(0)));
    } else {
      setDashboardPath(``);
    }
  }, [user]);

  useEffect(() => {
    if (token && role !== ROLES.STAFF) getRestaurants();
  }, [role]);

  useEffect(() => {
    const allRoutes = Object.values(getRoutes());

    const filteredPublicRoutes = _.filter(allRoutes, (route) => !route?.permission);

    const filteredPrivateRoutes = _.filter(allRoutes, (route) => {
      return route?.permission && route?.allowRoles?.includes(role);
    });

    setPublicRoutes(filteredPublicRoutes);
    setPrivateRoutes(filteredPrivateRoutes);

    switch (role) {
      case ROLES.SUPERADMIN:
      case ROLES.ADMIN:
        setDashboardPath(`/${ROLES.ADMIN}/dashboard`);
        break;
      case ROLES.MANAGER:
        setDashboardPath(`/${ROLES.MANAGER}/dashboard`);
        break;
      case ROLES.STAFF:
        getStaffRestaurants();
        break;
      default:
        break;
    }
  }, [token, role, user, getStaffRestaurants]);

  return (
    <Layout style={{ height: '100vh', overflow: 'auto' }}>
      <Layout className="site-layout">
        <Content>
          <Routes>
            {/* Public routes */}
            {!token && (
              <Route element={<PublicRoute />}>
                {publicRoutes.map((route) => (
                  <Route
                    key={route.name}
                    path={route.path}
                    element={route.element && <route.element />}
                  />
                ))}
                <Route path="*" element={<Navigate to={getRoutes().login.route()} />} />
              </Route>
            )}

            {/* Private routes */}
            <Route element={<PrivateRoute />}>
              {privateRoutes.map((route) => (
                <Route
                  key={route.name}
                  path={route.path}
                  element={route.element && <route.element />}
                />
              ))}
              {dashboardPath ? (
                <Route path="*" element={<Navigate to={dashboardPath} />} />
              ) : (
                <Route
                  path="*"
                  element={
                    <NotFound
                      details={
                        role === ROLES.STAFF && !user?.restaurants?.length
                          ? {
                              title: 'Site Not Assigned',
                              subTitle:
                                'No site is currently assigned, please contact your site manager',
                            }
                          : null
                      }
                    />
                  }
                />
              )}
            </Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
